"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BindNftInvite = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var guMember_1 = require("../../model/guMember");
var service_1 = require("../../../library/base/service");
var BindNftInvite = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(BindNftInvite, _super);
    function BindNftInvite() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '绑定nft邀请';
        _this.code = '101311';
        _this.desc = '绑定nft邀请';
        _this.requestParams = new guMember_1.RegistOrLoginRequest();
        _this.method = fetch_1.Methods.POST;
        return _this;
    }
    return BindNftInvite;
}(service_1.BaseService));
exports.BindNftInvite = BindNftInvite;
//# sourceMappingURL=bindNftInvite.js.map